import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { ComponentType } from '@/configuration/component/component-types'

export const useGeneralCommentsDeleteFileMutation = (generalCommentComponentType: ComponentType) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async (payload: { fileId?: number, generalCommentComponentSid: string}) =>
            hcaClientFactory.generalCommentsApi.deleteGeneralCommentFile(payload.fileId),
        onSuccess: async (_response, payload) => {
            if (generalCommentComponentType === ComponentType.Transformer) {
                await queryClient.resetQueries({ queryKey: ['transformers', payload.generalCommentComponentSid, 'generalComments'] })
            } else if (generalCommentComponentType === ComponentType.Generator) {
                await queryClient.resetQueries({ queryKey: ['generators', payload.generalCommentComponentSid, 'generalComments'] })
            }
        },
    })
}
